import { Link } from 'react-router';

import Text from '@cartwhl/ui/base/Text';
import ChevronRightIcon from '@cartwhl/ui/icons/ChevronRightIcon';

interface GreenLinkProps {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  className?: string;
}

function isExternalHref(href: string) {
  return href.startsWith('mailto:') || href.startsWith('http');
}

export default function GreenLink({
  children,
  href,
  onClick,
  className,
}: GreenLinkProps) {
  const baseClassName = `transition-color hover:text-green-60 cursor-pointer text-green-50 ${className}`;

  const content = (
    <Text
      as="span"
      variant="web/display/lg"
      lg:variant="web/display/xl"
      className="flex items-center"
    >
      {children}
      <ChevronRightIcon className="-mt-0.5 h-7 w-7 lg:h-10 lg:w-10" />
    </Text>
  );

  if (href) {
    return (
      <Link
        to={href}
        className={baseClassName}
        {...(isExternalHref(href)
          ? { target: '_blank', rel: 'noopener noreferrer' }
          : {})}
      >
        {content}
      </Link>
    );
  }

  return (
    <button onClick={onClick} className={`text-left ${baseClassName}`}>
      {content}
    </button>
  );
}
